// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nlk74","colBig":"styles_colBig__rsQam","colSmall":"styles_colSmall__1_QMm"};